import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { HeaderBlock } from '../../components/RentalCarContract'
import { Copy, Box, Flex, Button, BrowserWrapper, Image, WebviewWrapper } from '@elparking/components'
import DetailsBlockWithLoader from './DetailsBlock'
import CancelButton from '../../components/CancelButton'
import { FormattedMessage } from 'react-intl'
import { Cancel } from '../../components/Icons'
import { sendCloseWebviewEvent } from 'commons/js/services/sendMessage'
import EditButton from 'rental-car-contract/js/components/EditBookingButton/EditBookingButton'
import Calendar from 'rental-car-contract/js/components/Icons/Calendar'
import { bookingDetailPageName } from 'commons/js/services/analytics/TealiumEventsCollection/rentalCar'

const StyledCancelButton = ({ disableButton, onClick }) => <Button.unstyled
  dataTest='cancel-button-rental-car'
  borderRadius='3px'
  padding='0'
  fontSize='small'
  hoverColor={disableButton ? 'gray80' : 'main'}
  fontColor={disableButton ? 'gray80' : 'main'}
  height='auto'
  disabled={disableButton}
  width='auto'
  textTransform='none'
  fontWeight='book'
  onClick={onClick}>
    <Flex alignItems='center' gridGap='0.5em'>
        <Cancel color={disableButton ? 'gray80' : 'main'} height='40px' />
        <span>
            <FormattedMessage defaultMessage='Cancelar reserva' />
        </span>
    </Flex>
</Button.unstyled>

StyledCancelButton.propTypes = {
    disableButton: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
}

const StyledEditButton = ({ disableButton, onClick }) => <Button.unstyled
  dataTest='edit-button-rental-car'
  borderRadius='3px'
  padding='0'
  fontSize='small'
  hoverColor={disableButton ? 'gray80' : 'main'}
  fontColor={disableButton ? 'gray80' : 'main'}
  height='auto'
  disabled={disableButton}
  width='auto'
  textTransform='none'
  fontWeight='book'
  onClick={onClick}>
    <Flex alignItems='center' gridGap='0.5em'>
        <Calendar color={disableButton ? 'gray80' : 'main'} height='40px' />
        <span>
            <FormattedMessage defaultMessage='Modificar reserva' />
        </span>
    </Flex>
</Button.unstyled>

StyledEditButton.propTypes = {
    disableButton: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
}
const EditBookingBlock = ({ id, onSuccess, token }) => <Box width='100%'>
    <EditButton
      token={token}
      button={StyledEditButton}
      onSuccess={onSuccess}
      id={id}
      pageName={bookingDetailPageName} />
</Box>

EditBookingBlock.propTypes = {
    id: PropTypes.any.isRequired,
    onSuccess: PropTypes.func.isRequired,
    token: PropTypes.string,
}
const CancelBlock = ({ id, onSuccess, token }) => <Box width='100%'>
    <CancelButton
      token={token}
      button={StyledCancelButton}
      onSuccess={onSuccess}
      id={id}
      pageName={bookingDetailPageName} />
</Box>

CancelBlock.propTypes = {
    id: PropTypes.any.isRequired,
    onSuccess: PropTypes.func.isRequired,
    token: PropTypes.string,
}

const Content = ({
    id,
    booking,
    user,
    isLoading,
    isMutuaUser,
    request,
    token,
    error,
}) => {
    useEffect(() => {
        token && !error && !isLoading && !booking && request({id, token})
    }, [booking, isLoading, request, token, id, error])

    if (!booking || isLoading) {
        return null
    }

    return <Box width='100%'>
        <WebviewWrapper>
            <Flex position='fixed' background='white' mb='1em' ml='1em' width='100%' textAlign='left' alignItems='center' justifyContent='center' height='4em' zIndex='2'>
                <Box flex={1}>
                    <Button.unstyled onClick={() => sendCloseWebviewEvent()}><Image alt='back-button' src='/images/rental-car/back-button.svg' /></Button.unstyled>
                </Box>
                <Box flex={2}>
                    <Copy padding='0' fontSize='large' fontWeight='bold'><FormattedMessage defaultMessage='Reserva #{id}' values={{id: id}} /> </Copy>
                </Box>
            </Flex>
        </WebviewWrapper>
        <Box width='100%' padding='1em'>
            {!isLoading && user &&
                <BrowserWrapper>
                    <HeaderBlock user={user} cancelled={booking.cancelled} />
                </BrowserWrapper>
            }
            <DetailsBlockWithLoader
              token={token}
              booking={booking}
              isLoading={isLoading}
              cancelBlock={CancelBlock}
              editBookingBlock={EditBookingBlock}
              isMutuaUser={isMutuaUser}/>
        </Box>
    </Box>
}

Content.defaultProps = {
    request: () => {},
}

Content.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    booking: PropTypes.object,
    user: PropTypes.object,
    isMutuaUser: PropTypes.bool,
    request: PropTypes.func,
    id: PropTypes.number,
    token: PropTypes.string,
    error: PropTypes.any,
}

export default Content
